import React, { useRef, useEffect } from 'react';
import { FiSend } from 'react-icons/fi';
import { IconButton } from '../../design-system';
import { canSendChatMessage } from '../../types/chat';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  chatStatus: string;
}

export const ChatInput: React.FC<ChatInputProps> = ({ 
  value, 
  onChange, 
  onSubmit, 
  isLoading, 
  chatStatus 
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const canSend = canSendChatMessage(chatStatus);
  const isDisabled = isLoading || !canSend;
  const placeholder = !canSend
    ? "لطفاً تا تموم شدن پاسخ دستیار صبر کن."
    : "پیامت رو بنویس";
  
  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit(e as unknown as React.FormEvent);
    }
  };
  
  return (
    <div className="bg-composer-v3 pointer-events-none absolute inset-x-0 bottom-0 px-2.5 pb-3.5 pt-2.5 app-sm:px-6 app-sm:pb-[18px] app-sm:pt-3.5">
      <form onSubmit={onSubmit} className="pointer-events-auto mx-auto max-w-[920px]">
        <div className="flex items-end gap-2 rounded-ds-12 border-2 border-ds-200 bg-ds-white p-1.5 shadow-ds-1 transition-[border-color,box-shadow] focus-within:border-ds-primary focus-within:shadow-[0_0_0_3px_rgb(var(--ds-primary-200))] app-sm:rounded-ds-16 app-sm:p-2">
          <textarea
            ref={textareaRef}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            disabled={isDisabled}
            rows={1}
            className="block min-h-[38px] flex-1 resize-none border-0 bg-transparent px-2.5 py-2 text-[13px] leading-[22px] text-ds-ink outline-none placeholder:text-ds-400 app-sm:min-h-[42px] app-sm:text-sm"
            style={{ maxHeight: '120px' }}
          />
          <IconButton
            type="submit"
            disabled={isDisabled || !value.trim()}
            className="h-9 w-9 bg-ds-primary text-white hover:bg-ds-primary-strong app-sm:h-10 app-sm:w-10"
            aria-label="ارسال پیام"
          >
            <FiSend className="rtl-flip" size={18} />
          </IconButton>
        </div>
        <p className="mt-1.5 hidden text-center text-[9px] text-ds-500 app-sm:block">پاسخ‌ها ممکنه خطا داشته باشن؛ جزئیات محصول و شرایط خرید رو بررسی کن.</p>
      </form>
    </div>
  );
};
